import { useQuery } from '@tanstack/react-query';

import { VaultDocument } from '@/types/vault';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

const METHOD = 'GET';
const ENDPOINT = 'contacts/:contactId/documents';

export type ApiRequest_GetContactDocuments = {
  contactId: number;
  location_id: number;
};

export type ApiResponse_GetContactDocuments = VaultDocument[];

export const QUERY_KEY = (params: ApiRequest_GetContactDocuments) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetContactDocuments = (params: ApiRequest_GetContactDocuments, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: QUERY_KEY(params),
    enabled: enabled && !!session?.access_token && !!params.contactId && !!params.location_id,
    queryFn: async () => {
      const data = await handleApiCall<ApiResponse_GetContactDocuments>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { contactId: params.contactId.toString() }),
        undefined,
        {
          params: {
            location_id: params.location_id,
          },
        }
      );

      return data;
    },
  });
};
